import * as React from "react"

export const BlogIcon = ({
  width = 40,
  height = 40,
  ...rest
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...rest}
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={width} height={height} rx="8" fill="#F9F2FF" />

    <path
      d="M28.24 20.2483C29.3658 19.1225 29.9983 17.5955 29.9983 16.0033C29.9983 14.4112 29.3658 12.8842 28.24 11.7583C27.1142 10.6325 25.5872 10 23.995 10C22.4028 10 20.8758 10.6325 19.75 11.7583L13 18.5083V27.0083H21.5L28.24 20.2483Z"
      stroke="#7026B9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 16.0083L10 30.0083"
      stroke="#7026B9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.5 23.0083H17"
      stroke="#7026B9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
